<template>
  <div class="c-main">
    <div class="banner">
      <div class="priceImgs" v-for="(item, index) in priceImgs.list" :key="index">
        <img :src="BASE_URL + item.imageUrls" v-if="item.imageUrls" />
      </div>
    </div>
  </div>
</template>

<script>
import { getConf } from "../../api/article";

export default {
  name: "productCenter",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      priceImgs: {},
    };
  },
  created() {
    this.fetchHomeConf();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.priceImgs = JSON.parse(response.data.price) || {};
        console.log(this.priceImgs, "priceImgs");
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.c-main {
  min-height: calc(100vh - 100px);
  padding-bottom: 60px;
  box-sizing: border-box;
}

.banner {
  width: 1200px;
  height: auto;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
